import fetch from '@/utils/fetch'

// 根据题目的guid得到此题目的解题过程列表
export function getSolutionList (pguid) {
  return fetch({
    url: '/manager_getSolutionList',
    params: {
      pguid
    },
    method: 'get'
  })
}

export function getSolutionByGuid (guid) {
  console.log('guid---guid=' + guid)
  return fetch({
    url: '/getSolutionByGuid_manager',
    params: {
      guid
    },
    method: 'get'
  })
}

export function addNewSolution (data) {
  return fetch({
    url: '/addNewSolution',
    data,
    method: 'post'
  })
}

export function updateSolutionByGuid (data) {
  return fetch({
    url: '/updateSolutionByGuid',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_solution.js